// PageErrorProvider.tsx
import { useState, useCallback } from "react";
import { PageErrorContext } from "./PageErrorContext";
import { useErrorMessageMapping } from "../../hooks/useErrorMessageMapping";
import { FormErrorsState } from "../../types/types";

export const PageErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [formErrors, setFormErrors] = useState<FormErrorsState | null>(null);

  const mapErrors = useErrorMessageMapping();

  const mapAndSetErrors = useCallback(
    async (err: unknown) => {
      const result = await mapErrors(err as any);
      setFormErrors(result);
    },
    [mapErrors]
  );
  // const mapAndSetErrors = useCallback(async (err: unknown) => {
  //   let payload: APIError[] | Response | Error;

  //   if (axios.isAxiosError(err)) {
  //     payload = err.response?.data ?? new Error(err.message);
  //   } else if (err instanceof Error || err instanceof Response) {
  //     payload = err;
  //   } else {
  //     payload = new Error("Unknown error");
  //   }

  //   const result = await mapErrors(payload);
  //   setFormErrors(result);
  // }, [mapErrors]);

  const clearErrors = useCallback(() => {
    setFormErrors(null);
  }, []);

  return (
    <PageErrorContext.Provider
      value={{ formErrors, setFormErrors, mapAndSetErrors, clearErrors }}
    >
      {children}
    </PageErrorContext.Provider>
  );
};